// libs
import { styled } from '@nykaa/ui-components';

// constants
import { BREAKPOINTS } from 'shared/styles/base';

// global components
import BaseImage from 'shared/components/Image';

export const Container = styled.div`
  padding: ${({ theme }) => `${theme.spacing.spacing120} 0`};
  border-top: 1px solid ${({ theme }) => theme.colors.textOutline};

  @media (max-width: ${BREAKPOINTS.DESKTOP}px) {
    width: 100vw;
    margin-left: -16px;
    padding: ${({ theme }) =>
      `${theme.spacing.spacing80} ${theme.spacing.spacing80} ${theme.spacing.spacing80}`};
  }
`;

export const Name = styled.div`
  ${({ theme }) => theme.typography.titleMedium};
  padding-top: ${({ theme }) => theme.spacing.spacing20};
  margin-bottom: ${({ theme }) => theme.spacing.spacing60};
  color: ${({ theme }) => theme.colors.textPrimary};

  @media (max-width: ${BREAKPOINTS.DESKTOP}px) {
    margin-bottom: ${({ theme }) => theme.spacing.spacing40};
    padding-top: ${({ theme }) => theme.spacing.spacing0};
    ${({ theme }) => theme.typography.titleSmall};
  }
`;

export const Row = styled.div`
  display: flex;

  @media (min-width: ${BREAKPOINTS.DESKTOP}px) {
    flex-direction: row-reverse;
  }
`;

export const ImageCtr = styled.div`
  border: 1px solid ${({ theme }) => theme.colors.textOutline};
  min-width: 90px;
  margin-bottom: auto;
`;

export const Bio = styled.div`
  margin-left: ${({ theme }) => theme.spacing.spacing120};
  ${({ theme }) => theme.typography.bodyMedium};
  color: ${({ theme }) => theme.colors.textPrimary};

  @media (max-width: ${BREAKPOINTS.DESKTOP}px) {
    ${({ theme }) => theme.typography.bodySmall};
    margin-left: 0;
    padding-right: ${({ theme }) => theme.spacing.spacing80};
  }
`;

export const Image = styled(BaseImage)`
  display: block;
  width: 100%;
  height: 100%;
  // margin-left: ${({ theme }) => theme.spacing.spacing80};

  @media (max-width: ${BREAKPOINTS.DESKTOP}px) {
    // margin-left: ${({ theme }) => theme.spacing.spacing80};
  }
`;
